declare global {
	interface Window {
		serviceCategories: {
			inject: string;
		};
	}
}

// export const getInjectablesCategoryId() = window.serviceCategories?.inject || '';
export const getInjectablesCategoryId = () => window.serviceCategories?.inject || '';
